export interface DbUserApp {
  dbName: string;
  collectionName: string;
  count: number;
  fields: string[];
  users: Array<Record<string, unknown> & { id: string }>;
}

export interface UserUpdatePayload {
  dbName: string;
  collectionName: string;
  userId: string;
  updates?: Record<string, unknown>;
  sensitiveUpdate?: {
    field: string;
    value: string;
  };
}

export async function getDbUserApps(adminKey: string): Promise<DbUserApp[]> {
  const response = await fetch("/api/admin/db-users", {
    headers: {
      "x-admin-key": adminKey,
    },
  });

  if (!response.ok) {
    const data = (await response.json().catch(() => null)) as {
      message?: string;
    } | null;
    throw new Error(data?.message || "Could not load database users.");
  }

  const data = (await response.json()) as { apps?: DbUserApp[] };
  return data.apps || [];
}

export async function updateDbUser(
  payload: UserUpdatePayload,
  adminKey: string,
): Promise<void> {
  const response = await fetch("/api/admin/db-users", {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "x-admin-key": adminKey,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const data = (await response.json().catch(() => null)) as {
      message?: string;
    } | null;
    throw new Error(data?.message || "Could not update user.");
  }
}
